import { z } from "zod";

export const createServerSchema = z.object({
    friendlyName: z
        .string({
            message: "Friendly name is required",
        })
        .min(1, {
            message: "Friendly name is required",
        })
        .min(3, {
            message: "Friendly name must be at least 3 characters long",
        })
        .max(16, {
            message: "Friendly name must be at most 16 characters long",
        }),
    selectGame: z
        .string({
            message: "You must select a game",
        })
        .min(1, {
            message: "You must select a game",
        }),
    enablePreaquaticaBeta: z.boolean().optional(),
    selectNode: z
        .string({
            message: "You must select a node",
        })
        .min(1, {
            message: "You must select a node",
        }),
    serverFolder: z.string().optional(),
});
